// extracted by mini-css-extract-plugin
export var subscribe = "styles-module--subscribe--1vQCn";
export var subscribe_info = "styles-module--subscribe_info--3ssue";
export var subscribe_info_l = "styles-module--subscribe_info_l--2NFqo";
export var subscribe_info_r = "styles-module--subscribe_info_r--3Ku0g";